<template>
	<v-layout row wrap v-show="showContent">
		<v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
			<v-expansion-panels>
				<v-expansion-panel>
					<v-list class="sumLayout" v-for="(item, index) in resultObject" :key="item.currency">
						<h3>{{item.currency}}</h3>
						<v-list-item>
							<div class="leftContent">Total sold items count:</div>
							<div class="rightContent">{{item.soldItems}}</div>
						</v-list-item>
						<v-list-item>
							<div class="leftContent">Total revenue gross:</div>
							<div class="rightContent">
								{{toCurrency(item.revenueGross, currencyFormat.locale, item.currency)}}
							</div>
						</v-list-item>
						<v-list-item>
							<div class="leftContent">Total transaction fee::</div>
							<div class="rightContent">
								{{toCurrency(item.transactionFees, currencyFormat.locale, item.currency)}}
							</div>
						</v-list-item>
						<v-divider v-if="index != Object.keys(resultObject).length -1"></v-divider>
					</v-List>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-flex>
	</v-layout>
</template>

<script>
import { toCurrency } from '../../helper/format'

export default {
	name: 'revenueSumReportSums',
	props: {
		tableContent: {},
		showContent: {
			required: true,
			type: Boolean,
		},
	},
	data() {
		return {
			currencyFormat: {
				locale: 'en-US',
			},
			result: [],
			resultObject: [],
		}
	},
	watch: {
		tableContent: {
			async handler() {
				await this.sortAccordingCurrentcies()
			},
		},
	},
	methods: {
		toCurrency,
		async sortAccordingCurrentcies() {
			this.resultObject = []
			const uniqueCurrencies = [...new Set(this.tableContent.map((x) => x.order_currency_code))]
			// eslint-disable-next-line prefer-const
			for (let uniqueCurrency of uniqueCurrencies) {
				// eslint-disable-next-line arrow-body-style
				this.result[uniqueCurrency] = this.tableContent.filter((content) => {
					return (content.order_currency_code == uniqueCurrency)
				})

				const object = {
					// eslint-disable-next-line max-len, no-return-assign, no-new-wrappers
					soldItems: this.result[uniqueCurrency].reduce((acc, val) => acc += new Number(val.sum_of_sold_products), 0),
					// eslint-disable-next-line max-len, no-return-assign, no-new-wrappers
					revenueGross: this.result[uniqueCurrency].reduce((acc, val) => acc += new Number(val.sum_of_revenue_gross), 0),
					// eslint-disable-next-line max-len, no-return-assign, no-new-wrappers
					transactionFees: this.result[uniqueCurrency].reduce((acc, val) => acc += new Number(val.transaction_fee), 0),
					currency: uniqueCurrency,
				}
				this.resultObject.push(object)
			}
		},
	},
}

</script>

<style scoped>
.rightContent{
	margin-left: auto;
	margin-right: 0;
	font-weight: bold;
}

.sumLayout{
	background-color: rgba(214, 213, 213, 0.2);
}
</style>
